import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import Navbar from "./components/NavBar";
import Footer from "./components/Footer";

const NewsDetails = () => {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const docRef = doc(db, "news", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setNewsItem(docSnap.data());
        } else {
          setNewsItem(null);
        }
      } catch (error) {
        console.error("❌ خطأ أثناء تحميل الخبر:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, [id]);

  if (loading) return <p style={styles.loading}>⏳ جاري تحميل المقال...</p>;
  if (!newsItem)
    return (
      <div style={styles.container}>
        <p style={styles.error}>❌ لم يتم العثور على هذا المقال.</p>
        <button style={styles.backButton} onClick={() => navigate(-1)}>
          🔙 عودة
        </button>
      </div>
    );

  return (
    <>
    <Navbar/>
    <div style={styles.container}>
      <button style={styles.backButton} onClick={() => navigate(-1)}>
        🔙 رجوع
      </button>
      <h1 style={styles.title}>{newsItem.title}</h1>
      {newsItem.createdAt?.seconds && (
          <p style={styles.date}>
          🗓️ {new Date(newsItem.createdAt.seconds * 1000).toLocaleDateString("ar-EG")}
        </p>
      )}
      {newsItem.image && (
          <img src={newsItem.image} alt={newsItem.title} style={styles.image} />
      )}
      <div
        style={styles.content}
        dangerouslySetInnerHTML={{ __html: newsItem.content }}
      />
    </div>
<Footer/>
</>
  );
};

const styles = {
    container: {
        maxWidth: "900px",
    margin: "50px auto",
    padding: "30px",
    backgroundColor: "#fff",
    borderRadius: "14px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    direction: "rtl",
    fontFamily: "Cairo, sans-serif",
  },
  title: {
    color: "#004aad",
    fontSize: "2rem",
    marginBottom: "10px",
  },
  date: {
    color: "#777",
    marginBottom: "20px",
  },
  image: {
    width: "100%",
    borderRadius: "10px",
    marginBottom: "20px",
  },
  content: {
    color: "#333",
    fontSize: "1.1rem",
    lineHeight: "1.8",
  },
  loading: {
    textAlign: "center",
    color: "#004aad",
  },
  error: {
    textAlign: "center",
    color: "red",
    fontWeight: "600",
  },
  backButton: {
    background: "#004aad",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    cursor: "pointer",
    marginBottom: "20px",
    fontWeight: "600",
  },
};

export default NewsDetails;
